$('body').on('click', '.campaign-eur .donate-trigger', function () {
    $('.modal.add-donation-eur .select-ticket-trigger').removeClass('active');
    $('.modal.add-donation-eur').addClass('other');
    $('.add-donation-eur input[name="amount"]').val('0');
    $('.modal.add-donation-eur .other-amount input').select();
    openModal('.add-donation-eur');
    return false;
});

$('body').on('click', '.campaign-eur .open-campaign-video', function () {
    var $this = $(this);
    $('.campaign-video iframe').attr('src', $this.attr('href'));
    openModal('.campaign-video', 300);
    return false;
});



$('body').on('click', '.campaign-eur .to-tickets-trigger', function() {
    $('html, body').animate({
        scrollTop: $('.add-donation-eur').offset().top
    }, 300);
    
    return false;
});

function updateSummeryEUR() {
    // var selected = $('.campaign-eur .select-ticket-trigger.active');
    // var tickets = selected.length ? parseFloat(selected.attr('data-tickets')) : 0;
    var tickets = 0;
    var amount = parseFloat($('.campaign-eur [name="amount"]').val());
    $('.campaign-eur .select-ticket-trigger').each(function() {
        var ticket = $(this);
        if(amount >= parseFloat(ticket.attr('data-amount'))) {
            tickets = parseInt(ticket.attr('data-tickets'));
        }
    });

    $('.donation-summary .cart').html('');
    $('.donation-summary .total ul').html('');

    if(amount) {
        $('.donation-summary .cart').append(`<li>
            <span>€${amount} Donation - ${tickets} Ticket${tickets == 1 ? '' : 's'}</span>
            <span class="price">€${amount}</span>
        </li>`);
    }

    if ($('.campaign-eur .promo').length) {
        var promo = $('.campaign-eur .promo');

        if(promo.attr('data-mode') == 'tickets') {
            tickets += parseFloat(promo.attr('data-tickets'));

            $('.donation-summary .total ul').append(`<li>
                <span>Promo Tickets</span>
                <span class="price">${promo.attr('data-tickets')}</span>
            </li>`);
        }

        if (promo.attr('data-mode') == 'discount') {
            amount-= parseFloat(promo.attr('data-discount'));

            $('.donation-summary .total ul').append(`<li>
                <span>Promo Discount</span>
                <span class="price">€${promo.attr('data-discount')}</span>
            </li>`);
        }
    }

    // $('.campaign-eur .summery .total-amount').html(amount.toFixed(2));
    // $('.campaign-eur .summery .total-tickets').html(tickets);

    $('.donation-summary .total ul').append(`<li class="grand-total">
        <span>Total</span>
        <span class="price">€${amount.toFixed(2)}</span>
    </li>`);

    $('.donation-summary').show();
}

// validate the promo code
function validateEURPromo() {
    $('.promo .code-error, .promo .invalid').hide();

    if ($('.add-donation-eur input[name="amount"]').length && parseFloat($('.add-donation-eur input[name="amount"]').val()) <= 0) {
        $('.promo .code-error').show();
        $('input[name="coupon"]').val('');
        return false;
    }

    $.ajax({
        type: 'POST',
        url: '/coupons',
        data: {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'GET',
            'currency': 'EUR',
            'amount': $('.add-donation-eur input[name="amount"]').val(),
            'coupon': $('.add-donation-eur input[name="coupon"]').val()
        },
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                $('.add-donation-eur .promo .input-wrapper').hide();
                // $('.add-donation-eur .promo .applied .code').html(data.code);
                // $('.add-donation-eur .promo .applied .tickets').html(data.tickets);
                $('.add-donation-eur .promo .applied').show();
                $('.add-donation-eur .promo .applied p').html(data.message);

                $('.add-donation-eur .promo').attr('data-mode', data.mode);
                $('.add-donation-eur .promo').attr('data-tickets', data.tickets);
                $('.add-donation-eur .promo').attr('data-discount', data.discount);
            } else {
                $('.add-donation-eur .promo .invalid').show();
                $('.add-donation-eur .promo .input-wrapper').show();
                $('.add-donation-eur .promo .applied').hide();
            }

            updateSummeryEUR();
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
}

$('body').on('click', '.campaign-eur .select-ticket-trigger', function() {
    var $this = $(this);
    var amount = parseFloat($this.attr('data-amount'));

    $('.campaign-eur .select-ticket-trigger').removeClass('active');
    $this.addClass('active');

    // $('.campaign-eur .other-amount input').val(amount);
    $('.campaign-eur [name="amount"]').val(amount);
    $('.campaign-eur .select-ticket-trigger').removeClass('active');
    $('.campaign-eur .select-ticket-trigger[data-amount="' + amount + '"]').addClass('active');


    if($('.multiplier').length) {
        var multiplier = parseFloat($('.multiplier').attr('data-multiplier'));
        var max_prize = parseFloat($('.multiplier').attr('data-max_prize'));

        multiplier = amount*multiplier;
        multiplier = multiplier > max_prize ? max_prize : multiplier;

        $('.multiplier [data-input="donation"]').html(`${amount.toFixed(amount % 1 != 0 ? 2 : 0)}`);
        $('.multiplier [data-input="prize"]').html(`€${numberWithCommas(multiplier.toFixed(multiplier % 1 != 0 ? 2 : 0))}`);
    }

    $('.add-donation-eur .other-amount .ticket').html($this.attr('data-tickets'));
    $('.add-donation-eur .other-amount input').val(amount);

    // updateSummeryEUR();
    // $('.add-donation-eur .buy-tickets').addClass('visible');

    // if ($('.campaign-eur .promo').length && $('.campaign-eur .promo input').val()) {
    //     validateEURPromo();
    // }

    // $('html, body').animate({
    //     scrollTop: $('.add-donation-eur .buy-tickets').offset().top
    // }, 300);
    // $('.add-donation-eur .buy-tickets input[name="first_name"]').focus();
    return false;
});

$('body').on('focus keyup blur', '.add-donation-eur .other-amount input', function () {
    var $this = $(this);
    var amount = parseFloat($this.val().replace('€ ', ''));
    amount = isNaN(amount) ? 0 : amount;

    $('.campaign-eur .select-ticket-trigger').removeClass('active');

    if ($('.multiplier').length) {
        var multiplier = parseFloat($('.multiplier').attr('data-multiplier'));
        var max_prize = parseFloat($('.multiplier').attr('data-max_prize'));

        multiplier = amount*multiplier;
        multiplier = multiplier > max_prize ? max_prize : multiplier;

        $('.multiplier [data-input="donation"]').html(`${amount.toFixed(amount % 1 != 0 ? 2 : 0)}`);
        $('.multiplier [data-input="prize"]').html(`€${numberWithCommas(multiplier.toFixed(multiplier % 1 != 0 ? 2 : 0))}`);
    }

    $('.add-donation-eur [name="amount"]').val(amount);

    if ($('.multiplier').length) {
        var tickets = 0;
        var data = JSON.parse($('.multiplier').attr('data-tickets'));
        $.each(data, function(index, ticket) {
            if (amount >= parseFloat(ticket.amount)) {
                tickets = ticket.tickets;
            }
        });
        $('.add-donation-eur .other-amount .ticket').html(tickets);

        if(tickets == 0) {
            $('.multiplier [data-input="prize"]').html(`€0`);
        }
    }
});

// $('body').on('blur', '.add-donation-eur .other-amount input', function() {
//     var $this = $(this);
//     var amount = parseFloat($this.val().replace('€ ', ''));
//     amount = isNaN(amount) ? 0 : amount;
//     $('.add-donation-eur [name="amount"]').val(amount);
//     updateSummeryEUR();

//     if ($('.campaign-eur .promo').length && $('.campaign-eur .promo input').val()) {
//         validateEURPromo();
//     }
    
//     return false;
// });

$('body').on('click', '.campaign-eur .donate-other-trigger', function () {
    $('.add-donation-eur .select-ticket-trigger').removeClass('active');

    var input = $('.add-donation-eur .other-amount input');
    var amount = parseFloat(input.val().replace('€ ', ''));
    amount = isNaN(amount) ? 0 : amount;

    if (!amount) {
        $('.add-donation-eur .other-amount input').focus();
        return false;
    }

    updateSummeryEUR();
    $('.add-donation-eur .buy-tickets').addClass('visible');

    if ($('.campaign-eur .promo').length && $('.campaign-eur .promo input').val()) {
        validateEURPromo();
    }

    $('html, body').animate({
        scrollTop: $('.add-donation-eur .buy-tickets').offset().top
    }, 300);
    $('.add-donation-eur .buy-tickets input[name="first_name"]').focus();
    return false;
});

$('body').on('blur', '.add-donation-eur input[name="coupon"]', function() {
    validateEURPromo();
    return false;
});

$('body').on('click', '.add-donation-eur .apply-promo', function () {
    validateEURPromo();
    return false;
});

$('body').on('click', '.add-donation-eur .remove-coupon', function() {
    $('.campaign-eur .promo input').val('');
    $('.add-donation-eur .promo').attr('data-mode', '');
    $('.add-donation-eur .promo').attr('data-tickets', '');
    $('.add-donation-eur .promo').attr('data-discount', '');
    $('.add-donation-eur .promo .invalid').hide();
    $('.add-donation-eur .promo .applied').hide();
    $('.add-donation-eur .promo .input-wrapper').show();
    updateSummeryEUR();
    return false;
});


// submit the donation

$('body').on('click', '.add-donation-eur .doante-with-paypal', function() {
    var $this = $('.add-donation-eur form');

    var amount = parseFloat($('.add-donation-eur input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if (!amount) {
        showNotice('Erreur', 'Merci d\'indiquervotre montant', 'Fermer');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required.paypal', $this).each(function () {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Erreur', 'Merci de compléter tous les champs obligatoires', 'Fermer');
        return false;
    }

    if (emailError) {
        showNotice('Erreur', 'Please enter a valid email address', 'Fermer');
        return false;
    }

    loading();
    var payload = {};

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload.first_name = $('input[name="first_name"]', $this).val();
    payload.last_name = $('input[name="last_name"]', $this).val();
    payload.street = $('input[name="street"]', $this).val();
    payload.city = $('input[name="city"]', $this).val();
    payload.state = $('input[name="state"]', $this).val();
    payload.zip = $('input[name="zip"]', $this).val();
    payload.email = $('input[name="email"]', $this).val();
    payload.phone = $('input[name="phone"]', $this).val();
    payload.coupon = $('input[name="coupon"]', $this).val();
    payload.amount = $('input[name="amount"]', $this).val();
    payload.source = $('input[name="source"]', $this).val();
    payload.team = $('input[name="team"]', $this).val();
    payload.message = $('[name="message"]', $this).val();
    payload.method = 'paypal';
    payload.currency = 'EUR';

    if ($('input[name="anonymous"]', $this).prop('checked')) {
        payload.anonymous = true;
    }

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);

            if (!data.success) {
                unloading();
                showNotice('Error', data.message, 'close');
                return false;
            }

            if (data.location) {
                window.location.href = data.location;
                return false;
            }

            unloading();
            $this[0].reset();
            closeModal();
            showNotice('Success', data.message, 'close');
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    
    return false;
});

$('body').on('click', '.add-donation-eur .doante-with-cashapp', function () {
    var $this = $('.add-donation-eur form');

    var amount = parseFloat($('.add-donation-eur input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if (!amount) {
        showNotice('Erreur', 'Merci d\'indiquervotre montant', 'Fermer');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required.cashapp', $this).each(function () {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Erreur', 'Merci de compléter tous les champs obligatoires', 'Fermer');
        return false;
    }

    if (emailError) {
        showNotice('Erreur', 'Please enter a valid email address', 'Fermer');
        return false;
    }

    loading();
    var payload = {};

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload.first_name = $('input[name="first_name"]', $this).val();
    payload.last_name = $('input[name="last_name"]', $this).val();
    payload.street = $('input[name="street"]', $this).val();
    payload.city = $('input[name="city"]', $this).val();
    payload.state = $('input[name="state"]', $this).val();
    payload.zip = $('input[name="zip"]', $this).val();
    payload.email = $('input[name="email"]', $this).val();
    payload.phone = $('input[name="phone"]', $this).val();
    payload.coupon = $('input[name="coupon"]', $this).val();
    payload.amount = $('input[name="amount"]', $this).val();
    payload.source = $('input[name="source"]', $this).val();
    payload.team = $('input[name="team"]', $this).val();
    payload.message = $('[name="message"]', $this).val();
    payload.method = 'cashapp';
    payload.currency = 'EUR';

    if ($('input[name="anonymous"]', $this).prop('checked')) {
        payload.anonymous = true;
    }

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);

            if (!data.success) {
                unloading();
                showNotice('Error', data.message, 'close');
                return false;
            }

            if (data.location) {
                window.location.href = data.location;
                return false;
            }

            unloading();
            $this[0].reset();
            closeModal();
            showNotice('Success', data.message, 'close');
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('submit', '.add-donation-eur form', function() {
    var $this = $(this);

    var amount = parseFloat($('.add-donation-eur input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if(!amount) {
        showNotice('Erreur', 'Merci d\'indiquervotre montant', 'Fermer');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required.card', $this).each(function() {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Erreur', 'Merci de compléter tous les champs obligatoires', 'Fermer');
        return false;
    }

    if (emailError) {
        showNotice('Erreur', 'Please enter a valid email address', 'Fermer');
        return false;
    }

    loading();
    var payload = {};

    // setup the token
    Stripe.setPublishableKey($('meta[name="stripe"]').attr('content'));
    Stripe.card.createToken(
        {
            name: $('input[name="first_name"]', $this).val() + ' ' + $('input[name="last_name"]', $this).val(),
            number: $('input[name="card_number"]', $this).val(),
            cvc: $('input[name="cvv"]', $this).val(),
            exp: $('input[name="expiry"]', $this).val(),
            // exp_month: $('input[name="month"]', $this).val(),
            // exp_year: $('input[name="year"]', $this).val(),
            address_line1: $('input[name="street"]', $this).val(),
            address_state: $('input[name="state"]', $this).val(),
            address_zip: $('input[name="zip"]', $this).val()
        },
        function(status, response) {
            // console.log(response);
            if (response.error) {
                unloading();
                showNotice('Error', response.error.message, 'close');
                return false;
            }

            payload['_token'] = $('meta[name="csrf-token"]').attr('content');
            payload.stripe_token = response.id;

            payload.first_name = $('input[name="first_name"]', $this).val();
            payload.last_name = $('input[name="last_name"]', $this).val();
            payload.street = $('input[name="street"]', $this).val();
            payload.city = $('input[name="city"]', $this).val();
            payload.state = $('input[name="state"]', $this).val();
            payload.zip = $('input[name="zip"]', $this).val();
            payload.email = $('input[name="email"]', $this).val();
            payload.phone = $('input[name="phone"]', $this).val();
            payload.brand = response.card.brand;
            payload.last_four = response.card.last4;
            payload.month = response.card.exp_month;
            payload.year = response.card.exp_year;
            payload.coupon = $('input[name="coupon"]', $this).val();
            payload.amount = $('input[name="amount"]', $this).val();
            payload.source = $('input[name="source"]', $this).val();
            payload.team = $('input[name="team"]', $this).val();
            payload.message = $('[name="message"]', $this).val();
            payload.method = 'card';
            payload.currency = 'EUR';

            if ($('input[name="anonymous"]', $this).prop('checked')) {
                payload.anonymous = true;
            }

            $.ajax({
                type: 'POST',
                url: $this.attr('action'),
                data: payload,
                dataType: 'json',
                success: function(data) {
                    console.log(data);
                    unloading();

                    if (!data.success) {
                        showNotice('Error', data.message, 'close');
                        return false;
                    }

                    $this[0].reset();
                    closeModal();
                    $('.donation-thanks-eur [data-input="header"]').html(data.header);
                    $('.donation-thanks-eur [data-input="message"]').html(data.message);
                    openModal('.donation-thanks-eur', 500, true);
                    // showNotice('Success', data.message, 'close');
                },
                error: function(request) {
                    console.log(request.responseText);
                }
            });

            return false;
        }
    );

    return false;
});


$('body').on('click', '.open-campaign-rules-eur', function () {
    openModal('.campaign-rules-eur');
    return false;
});

channel.bind('process-campaign', function (data) {
    if ($('.project-progress-eur').length) {
        var stats = $('.project-progress-eur');

        if (data.bonus_percent > 0) {
            stats.addClass('bonus');
        }

        // update the totals
        stats.find('[data-input="total_donated_floored"]').html(data.total_donated_floored);
        stats.find('[data-input="total_donations"]').html(data.total_donations);
        stats.find('[data-input="bochurim_funded"]').html(data.bochurim_funded);

        // update the tool tips text
        stats.find('.tool-tip').html(`${data.goal_percent_rounded}%`);

        // update the bochurim
        stats.find('.project-progress .progress').attr('style', `--progress: ${data.percent_donated}%`);

        // update the progress bars
        stats.find('.main-progress .current-progress').css({
            width: data.goal_percent + '%'
        });

        // update the tooltip
        stats.find('.main-progress .tool-tip').css({
            left: data.goal_percent + '%'
        });

        // update the tooltip
        stats.find('.main-progress .tool-tip').css({
            left: data.goal_percent + '%'
        });

        // update the bonus
        stats.find('.bonus-progress .current-progress').css({
            width: data.bonus_percent + '%'
        });

        // update the tooltip
        stats.find('.bonus-progress .tool-tip').css({
            left: data.bonus_percent + '%'
        });

        // update the tooltip
        stats.find('.bonus-progress .tool-tip').css({
            left: data.bonus_percent + '%'
        });
    }
});